<div id="modal-content-wrapper">
  <form #f="ngForm" (ngSubmit)="f.form.valid && submit()">
    <div class="modal-header justify-content-center">
      <h4 class="title">{{ title }}</h4>
    </div>
    <div class="modal-body">
      <div>
        <label>User</label>
        <div *ngIf="update" class="form-group mb-3">
          <input type="text" name="name" [value]="profile.username" class="form-control" autocomplete="off" disabled required />
        </div>
        <div *ngIf="!update" class="form-group mb-3">
          <select class="form-select" name="user" [(ngModel)]="profile" [class.is-invalid]="profile == null" required>
            <option *ngFor="let p of profiles" [ngValue]="p">{{ p.username }}</option>
          </select>
        </div>
      </div>
      <div>
        <label>Licence</label>
        <div class="form-group mb-3">
          <select class="form-select" name="licence" [(ngModel)]="licence" [class.is-invalid]="licence == null" required>
            <option *ngFor="let l of licences" [ngValue]="l">{{ l.key }}</option>
          </select>
        </div>
      </div>
    </div>
    <!-- Buttons -->
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel')">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="!f.form.valid">Submit</button>
    </div>
  </form>
</div>
